import { IntlShape, useIntl } from "react-intl";
import BaseButton from "components/common/BaseButton";
import BaseModal from "./BaseModal";

interface Props {
  isOpen: boolean;
  isError: boolean;
  isSuccess: boolean;
  deletedEntityName: string;
  onClose: () => void;
  onConfirm?: () => void;
  loading?: boolean;
}

const generateModalTitle = (
  intl: IntlShape,
  isError: boolean,
  isSuccess: boolean,
  deletedEntityName: string
) => {
  if (isError) {
    return intl.formatMessage({ id: "usAdmin.deletionError" });
  }
  if (isSuccess) {
    return intl.formatMessage({ id: "usAdmin.deletionSuccess" });
  }

  return intl.formatMessage(
    { id: "usAdmin.deleteEntity" },
    { name: deletedEntityName }
  );
};

const generateFooterContent = (
  isError: boolean,
  isSuccess: boolean,
  loading: boolean,
  intl: IntlShape,
  onClose: () => void,
  onConfirm?: () => void
) => {
  if (isError) {
    return (
      <BaseButton
        handleSubmit={onClose}
        text={intl.formatMessage({ id: "usAdmin.ok" })}
      />
    );
  }
  if (isSuccess) {
    return (
      <BaseButton
        handleSubmit={onClose}
        text={intl.formatMessage({ id: "usAdmin.ok" })}
      />
    );
  }

  return (
    <>
      <BaseButton
        handleSubmit={onConfirm}
        text={intl.formatMessage({ id: "tableCellOverlay.yes" })}
        disabled={loading}
      />
      <BaseButton
        backgroundColor="red"
        handleSubmit={onClose}
        text={intl.formatMessage({ id: "tableCellOverlay.no" })}
      />
    </>
  );
};

const DeletionModal = ({
  isOpen,
  isError,
  isSuccess,
  deletedEntityName,
  onClose,
  onConfirm,
  loading = false,
}: Props) => {
  const intl = useIntl();

  let modalTitle = generateModalTitle(
    intl,
    isError,
    isSuccess,
    deletedEntityName
  );
  let footerContent = generateFooterContent(
    isError,
    isSuccess,
    loading,
    intl,
    onClose,
    onConfirm
  );

  return (
    <BaseModal isOpen={isOpen} onRequestClose={onClose} footer={footerContent}>
      <h2>{modalTitle}</h2>
    </BaseModal>
  );
};

export default DeletionModal;
